module.exports = __webpack_public_path__ + "assets/3rdProportionalDetailed.320da7346f5b231d7b516ec6f87d84cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/3rdProportionalDetailed.png
// module id = 446
// module chunks = 0